import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './staff@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="staff">
    <h1>教師團隊</h1>
    <p>
      國際化教師團隊是本校課程的基石。他們分別來自加拿大、澳洲、中國、香港、英國、蘇格蘭、南非及新西蘭。所有班主任的母語皆分別為英語或普通話，並且合乎教師資格，具備教授小學文憑課程的優秀條件。學校非常注重教師的持續培訓，因此會提供不同機會予教師參與國際文憑小學課程工作坊，以及其他相關的專業學習機會。
    </p>

    <img src={image} alt="Staff at KIS" />
  </ContentLayout>
);
